import React, { Suspense, Component } from 'react';

const EmbedMarketing = React.lazy(() => import('./EmbedMarketing'));

export default class EmbedMarketingWrapper extends Component {
  render() {
    return(
      <div>
        <Suspense>
          <EmbedMarketing config={this.props.config}/>
        </Suspense>
      </div>
    );
  }
}
